module.exports = __webpack_public_path__ + "106cf4702f52115120934deaa6727368.pdf";